import type { ComponentType, SVGProps } from 'react';

import type { realestatelst } from '@ps/models/lib/realestate-listing-page';

// ─── Icon Props ───────────────────────────────────────────────────────────

type IconProps = SVGProps<SVGSVGElement>;

// ─── Feature Type Icons ───────────────────────────────────────────────────

function PoolWaterIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 4.5C1.95 4.875 2.4 5.25 3.375 5.25C5.25 5.25 5.25 3.75 7.125 3.75C9.075 3.75 8.925 5.25 10.875 5.25C12.75 5.25 12.75 3.75 14.625 3.75C15.6 3.75 16.05 4.125 16.5 4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 9C1.95 9.375 2.4 9.75 3.375 9.75C5.25 9.75 5.25 8.25 7.125 8.25C9.075 8.25 8.925 9.75 10.875 9.75C12.75 9.75 12.75 8.25 14.625 8.25C15.6 8.25 16.05 8.625 16.5 9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 13.5C1.95 13.875 2.4 14.25 3.375 14.25C5.25 14.25 5.25 12.75 7.125 12.75C9.075 12.75 8.925 14.25 10.875 14.25C12.75 14.25 12.75 12.75 14.625 12.75C15.6 12.75 16.05 13.125 16.5 13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function GarageParkingIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.25 12.75H15.75C16.2 12.75 16.5 12.45 16.5 12V9.75C16.5 9.075 15.975 8.475 15.375 8.325C14.025 7.95 12 7.5 12 7.5C12 7.5 11.025 6.45 10.35 5.775C9.975 5.475 9.525 5.25 9 5.25H3.75C3.3 5.25 2.925 5.55 2.7 5.925L1.65 8.1C1.551 8.39 1.5 8.694 1.5 9V12C1.5 12.45 1.8 12.75 2.25 12.75H3.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 14.25C6.078 14.25 6.75 13.578 6.75 12.75C6.75 11.922 6.078 11.25 5.25 11.25C4.422 11.25 3.75 11.922 3.75 12.75C3.75 13.578 4.422 14.25 5.25 14.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 12.75H11.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 14.25C13.578 14.25 14.25 13.578 14.25 12.75C14.25 11.922 13.578 11.25 12.75 11.25C11.922 11.25 11.25 11.922 11.25 12.75C11.25 13.578 11.922 14.25 12.75 14.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function GardenLandscapeIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.75 10.5L15 12.975C15.103 13.08 15.173 13.213 15.201 13.357C15.229 13.501 15.214 13.65 15.158 13.786C15.102 13.921 15.008 14.038 14.886 14.12C14.765 14.203 14.622 14.248 14.475 14.25H3.525C3.378 14.248 3.235 14.203 3.114 14.12C2.992 14.038 2.898 13.921 2.842 13.786C2.786 13.65 2.771 13.501 2.799 13.357C2.827 13.213 2.897 13.08 3 12.975L5.25 10.5H5.025C4.878 10.498 4.735 10.453 4.614 10.37C4.492 10.288 4.398 10.171 4.342 10.036C4.286 9.9 4.271 9.751 4.299 9.607C4.327 9.463 4.397 9.33 4.5 9.225L6.75 6.75H6.6C6.447 6.764 6.293 6.73 6.16 6.654C6.026 6.577 5.92 6.462 5.854 6.322C5.789 6.183 5.767 6.027 5.794 5.876C5.82 5.724 5.892 5.584 6 5.475L9 2.25L12 5.475C12.108 5.584 12.18 5.724 12.207 5.876C12.233 6.027 12.212 6.183 12.146 6.322C12.081 6.462 11.974 6.577 11.84 6.654C11.707 6.73 11.553 6.764 11.4 6.75H11.25L13.5 9.225C13.603 9.33 13.673 9.463 13.701 9.607C13.729 9.751 13.714 9.9 13.658 10.036C13.602 10.171 13.508 10.288 13.386 10.37C13.265 10.453 13.122 10.498 12.975 10.5H12.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 16.5V14.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SecurityIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 9.75C15 13.5 12.375 15.375 9.255 16.463C9.092 16.518 8.914 16.515 8.753 16.455C5.625 15.375 3 13.5 3 9.75V4.5C3 4.301 3.079 4.11 3.22 3.97C3.36 3.829 3.551 3.75 3.75 3.75C5.25 3.75 7.125 2.85 8.43 1.71C8.589 1.574 8.791 1.5 9 1.5C9.209 1.5 9.411 1.574 9.57 1.71C10.883 2.858 12.75 3.75 14.25 3.75C14.449 3.75 14.64 3.829 14.78 3.97C14.921 4.11 15 4.301 15 4.5V9.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 9L8.25 10.5L11.25 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SmartHomeIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.644 1.721C8.677 1.655 8.727 1.599 8.79 1.56C8.853 1.521 8.926 1.5 9 1.5C9.074 1.5 9.147 1.521 9.21 1.56C9.273 1.599 9.323 1.655 9.356 1.721L11.089 5.231C11.203 5.461 11.371 5.661 11.58 5.813C11.788 5.964 12.03 6.063 12.285 6.101L16.16 6.668C16.233 6.678 16.302 6.709 16.359 6.757C16.415 6.805 16.458 6.867 16.481 6.938C16.504 7.009 16.506 7.084 16.488 7.156C16.471 7.228 16.433 7.294 16.38 7.346L13.578 10.074C13.393 10.254 13.255 10.476 13.175 10.722C13.095 10.967 13.076 11.228 13.12 11.483L13.781 15.338C13.794 15.411 13.786 15.486 13.758 15.556C13.731 15.625 13.684 15.685 13.623 15.728C13.563 15.772 13.492 15.798 13.417 15.803C13.343 15.808 13.269 15.793 13.203 15.758L9.74 13.937C9.511 13.817 9.257 13.754 9 13.754C8.742 13.754 8.488 13.817 8.26 13.937L4.797 15.758C4.731 15.792 4.657 15.808 4.583 15.803C4.509 15.797 4.437 15.771 4.377 15.728C4.317 15.684 4.27 15.624 4.242 15.555C4.215 15.486 4.207 15.411 4.22 15.338L4.88 11.483C4.924 11.229 4.905 10.968 4.825 10.722C4.745 10.477 4.607 10.254 4.422 10.074L1.62 7.346C1.566 7.295 1.528 7.229 1.51 7.157C1.492 7.084 1.495 7.008 1.518 6.938C1.541 6.867 1.583 6.804 1.64 6.756C1.697 6.708 1.767 6.677 1.841 6.667L5.714 6.101C5.969 6.063 6.212 5.965 6.42 5.813C6.629 5.662 6.798 5.462 6.912 5.231L8.644 1.721Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FloorPlanIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.975 11.475C16.143 11.642 16.276 11.841 16.367 12.06C16.458 12.279 16.504 12.513 16.504 12.75C16.504 12.987 16.458 13.222 16.367 13.44C16.276 13.659 16.143 13.858 15.975 14.025L14.025 15.975C13.858 16.143 13.659 16.276 13.44 16.367C13.222 16.458 12.987 16.504 12.75 16.504C12.513 16.504 12.279 16.458 12.06 16.367C11.841 16.276 11.642 16.143 11.475 15.975L2.025 6.525C1.688 6.186 1.499 5.728 1.499 5.25C1.499 4.772 1.688 4.314 2.025 3.975L3.975 2.025C4.314 1.688 4.772 1.499 5.25 1.499C5.728 1.499 6.186 1.688 6.525 2.025L15.975 11.475Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.875 9.375L12.375 7.875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.625 7.125L10.125 5.625"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function LuxuryPremiumIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.453 11.625C7.386 11.365 7.251 11.129 7.061 10.939C6.871 10.75 6.635 10.614 6.375 10.547L1.774 9.361C1.695 9.338 1.626 9.291 1.577 9.226C1.528 9.161 1.501 9.082 1.501 9C1.501 8.918 1.528 8.839 1.577 8.774C1.626 8.709 1.695 8.662 1.774 8.639L6.375 7.452C6.634 7.385 6.871 7.25 7.061 7.061C7.25 6.871 7.386 6.634 7.453 6.375L8.639 1.774C8.661 1.695 8.709 1.626 8.774 1.576C8.839 1.527 8.919 1.5 9 1.5C9.082 1.5 9.162 1.527 9.227 1.576C9.292 1.626 9.339 1.695 9.362 1.774L10.547 6.375C10.614 6.635 10.75 6.871 10.939 7.061C11.129 7.251 11.365 7.386 11.625 7.453L16.226 8.639C16.305 8.66 16.375 8.708 16.425 8.773C16.475 8.838 16.502 8.918 16.502 9C16.502 9.082 16.475 9.162 16.425 9.227C16.375 9.292 16.305 9.34 16.226 9.362L11.625 10.547C11.365 10.614 11.129 10.75 10.939 10.939C10.75 11.129 10.614 11.365 10.547 11.625L9.361 16.226C9.339 16.305 9.291 16.375 9.226 16.424C9.161 16.473 9.081 16.5 9 16.5C8.918 16.5 8.838 16.473 8.773 16.424C8.708 16.375 8.661 16.305 8.639 16.226L7.453 11.625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 2.25V5.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 3.75H13.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function GatedPrivateIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.25 8.25H3.75C2.922 8.25 2.25 8.922 2.25 9.75V15C2.25 15.828 2.922 16.5 3.75 16.5H14.25C15.078 16.5 15.75 15.828 15.75 15V9.75C15.75 8.922 15.078 8.25 14.25 8.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 8.25V5.25C5.25 4.255 5.645 3.302 6.348 2.598C7.052 1.895 8.005 1.5 9 1.5C9.995 1.5 10.948 1.895 11.652 2.598C12.355 3.302 12.75 4.255 12.75 5.25V8.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SolarEnergyIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 12C10.657 12 12 10.657 12 9C12 7.343 10.657 6 9 6C7.343 6 6 7.343 6 9C6 10.657 7.343 12 9 12Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 1.5V3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15V16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.697 3.697L4.758 4.758"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.242 13.242L14.303 14.303"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 9H3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9H16.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.697 14.303L4.758 13.242"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.242 4.758L14.303 3.697"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function EntertainmentIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.75 13.5V3.75L15.75 2.25V12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 15.75C5.743 15.75 6.75 14.743 6.75 13.5C6.75 12.257 5.743 11.25 4.5 11.25C3.257 11.25 2.25 12.257 2.25 13.5C2.25 14.743 3.257 15.75 4.5 15.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 14.25C14.743 14.25 15.75 13.243 15.75 12C15.75 10.757 14.743 9.75 13.5 9.75C12.257 9.75 11.25 10.757 11.25 12C11.25 13.243 12.257 14.25 13.5 14.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function KitchenDiningIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.5 1.5V3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 1.5V3"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C12.199 6 12.39 6.079 12.53 6.22C12.671 6.36 12.75 6.551 12.75 6.75V12.75C12.75 13.546 12.434 14.309 11.871 14.871C11.309 15.434 10.546 15.75 9.75 15.75H5.25C4.454 15.75 3.691 15.434 3.129 14.871C2.566 14.309 2.25 13.546 2.25 12.75V6.75C2.25 6.551 2.329 6.36 2.47 6.22C2.61 6.079 2.801 6 3 6H13.5C14.296 6 15.059 6.316 15.621 6.879C16.184 7.441 16.5 8.204 16.5 9C16.5 9.796 16.184 10.559 15.621 11.121C15.059 11.684 14.296 12 13.5 12H12.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FitnessGymIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8 10.8L7.2 7.2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.993 16.114C13.712 16.395 13.33 16.553 12.932 16.553C12.534 16.553 12.153 16.395 11.871 16.114C11.59 15.833 11.432 15.451 11.432 15.054C11.432 14.656 11.59 14.274 11.871 13.993L10.546 15.319C10.264 15.6 9.883 15.758 9.485 15.758C9.087 15.758 8.705 15.6 8.424 15.319C8.143 15.037 7.985 14.656 7.985 14.258C7.985 13.86 8.143 13.478 8.424 13.197L13.197 8.424C13.478 8.143 13.86 7.985 14.258 7.985C14.656 7.985 15.037 8.143 15.319 8.424C15.6 8.706 15.758 9.087 15.758 9.485C15.758 9.883 15.6 10.264 15.319 10.546L13.993 11.871C14.274 11.59 14.656 11.432 15.054 11.432C15.451 11.432 15.833 11.59 16.114 11.871C16.395 12.153 16.553 12.534 16.553 12.932C16.553 13.33 16.395 13.712 16.114 13.993L13.993 16.114Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.125 16.125L15.075 15.075"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.007 1.886C4.288 1.605 4.67 1.447 5.068 1.447C5.466 1.447 5.847 1.605 6.129 1.886C6.41 2.167 6.568 2.549 6.568 2.946C6.568 3.344 6.41 3.726 6.129 4.007L7.454 2.681C7.736 2.4 8.117 2.242 8.515 2.242C8.913 2.242 9.295 2.4 9.576 2.681C9.857 2.963 10.015 3.344 10.015 3.742C10.015 4.14 9.857 4.522 9.576 4.803L4.803 9.576C4.522 9.857 4.14 10.015 3.742 10.015C3.344 10.015 2.963 9.857 2.681 9.576C2.4 9.294 2.242 8.913 2.242 8.515C2.242 8.117 2.4 7.736 2.681 7.454L4.007 6.129C3.726 6.41 3.344 6.568 2.946 6.568C2.549 6.568 2.167 6.41 1.886 6.129C1.605 5.847 1.447 5.466 1.447 5.068C1.447 4.67 1.605 4.288 1.886 4.007L4.007 1.886Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 1.875L2.925 2.925"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function OfficeTechIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 2.25H3C2.172 2.25 1.5 2.922 1.5 3.75V11.25C1.5 12.078 2.172 12.75 3 12.75H15C15.828 12.75 16.5 12.078 16.5 11.25V3.75C16.5 2.922 15.828 2.25 15 2.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 15.75H12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.75V15.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function MediaRoomIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 5.25H3C2.172 5.25 1.5 5.922 1.5 6.75V15C1.5 15.828 2.172 16.5 3 16.5H15C15.828 16.5 16.5 15.828 16.5 15V6.75C16.5 5.922 15.828 5.25 15 5.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 1.5L9 5.25L5.25 1.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ConnectivityIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9 15H9.008"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.5 6.615C3.563 4.77 6.233 3.75 9 3.75C11.767 3.75 14.437 4.77 16.5 6.615"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 9.644C5.152 8.27 7.037 7.5 9 7.5C10.963 7.5 12.848 8.27 14.25 9.644"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12.675C6.788 11.927 7.872 11.25 9 11.25C10.128 11.25 11.212 11.927 12 12.675"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function PropertyTypeIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.25 15.75V9.75C11.25 9.551 11.171 9.36 11.03 9.22C10.89 9.079 10.699 9 10.5 9H7.5C7.301 9 7.11 9.079 6.97 9.22C6.829 9.36 6.75 9.551 6.75 9.75V15.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 7.5C2.25 7.282 2.298 7.066 2.389 6.868C2.481 6.67 2.615 6.495 2.782 6.354L8.032 1.855C8.302 1.626 8.646 1.5 9 1.5C9.354 1.5 9.698 1.626 9.968 1.855L15.218 6.354C15.385 6.495 15.519 6.67 15.611 6.868C15.703 7.066 15.75 7.282 15.75 7.5V14.25C15.75 14.648 15.592 15.029 15.311 15.311C15.029 15.592 14.648 15.75 14.25 15.75H3.75C3.352 15.75 2.971 15.592 2.689 15.311C2.408 15.029 2.25 14.648 2.25 14.25V7.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AwardFeatureIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.608 9.668L12.744 16.062C12.757 16.137 12.746 16.215 12.714 16.284C12.681 16.353 12.629 16.411 12.562 16.449C12.496 16.487 12.42 16.504 12.344 16.498C12.268 16.492 12.196 16.463 12.137 16.415L9.452 14.399C9.322 14.302 9.164 14.25 9.003 14.25C8.841 14.25 8.683 14.302 8.554 14.399L5.864 16.414C5.805 16.462 5.733 16.491 5.657 16.497C5.581 16.504 5.505 16.486 5.439 16.448C5.373 16.41 5.32 16.353 5.287 16.284C5.255 16.215 5.244 16.137 5.257 16.062L6.392 9.668"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 10.5C11.485 10.5 13.5 8.485 13.5 6C13.5 3.515 11.485 1.5 9 1.5C6.515 1.5 4.5 3.515 4.5 6C4.5 8.485 6.515 10.5 9 10.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function FireplaceHeatingIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.375 10.875C6.872 10.875 7.349 10.678 7.701 10.326C8.052 9.974 8.25 9.497 8.25 9C8.25 7.965 7.875 7.5 7.5 6.75C6.696 5.143 7.332 3.71 9 2.25C9.375 4.125 10.5 5.925 12 7.125C13.5 8.325 14.25 9.75 14.25 11.25C14.25 11.939 14.114 12.622 13.85 13.259C13.587 13.896 13.2 14.475 12.712 14.962C12.225 15.45 11.646 15.837 11.009 16.1C10.372 16.364 9.689 16.5 9 16.5C8.311 16.5 7.628 16.364 6.991 16.1C6.354 15.837 5.775 15.45 5.288 14.962C4.8 14.475 4.413 13.896 4.15 13.259C3.886 12.622 3.75 11.939 3.75 11.25C3.75 10.385 4.075 9.53 4.5 9C4.5 9.497 4.698 9.974 5.049 10.326C5.401 10.678 5.878 10.875 6.375 10.875Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function OtherIcon(props: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.44 1.94A1.5 1.5 0 0 0 8.38 1.5H3A1.5 1.5 0 0 0 1.5 3V8.38A1.5 1.5 0 0 0 1.94 9.44L8.47 15.97A1.82 1.82 0 0 0 11.04 15.97L15.97 11.04A1.82 1.82 0 0 0 15.97 8.47Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="5.25" cy="5.25" r="0.75" fill="currentColor" />
    </svg>
  );
}

// ─── Feature Type Registry ────────────────────────────────────────────────

export interface ListingFeatureItemInfo {
  id: realestatelst.ListingFeatureType;
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}

export const FEATURE_TYPES: ListingFeatureItemInfo[] = [
  { id: 'pool-water', label: 'Pool/Water', icon: PoolWaterIcon },
  { id: 'garage-parking', label: 'Garage/Parking', icon: GarageParkingIcon },
  {
    id: 'garden-landscape',
    label: 'Garden/Landscape',
    icon: GardenLandscapeIcon,
  },
  { id: 'security', label: 'Security', icon: SecurityIcon },
  { id: 'smart-home', label: 'Smart Home', icon: SmartHomeIcon },
  { id: 'floor-plan', label: 'Floor Plan', icon: FloorPlanIcon },
  { id: 'luxury-premium', label: 'Luxury/Premium', icon: LuxuryPremiumIcon },
  { id: 'gated-private', label: 'Gated/Private', icon: GatedPrivateIcon },
  { id: 'solar-energy', label: 'Solar/Energy', icon: SolarEnergyIcon },
  { id: 'entertainment', label: 'Entertainment', icon: EntertainmentIcon },
  { id: 'kitchen-dining', label: 'Kitchen/Dining', icon: KitchenDiningIcon },
  { id: 'fitness-gym', label: 'Fitness/Gym', icon: FitnessGymIcon },
  { id: 'office-tech', label: 'Office/Tech', icon: OfficeTechIcon },
  { id: 'media-room', label: 'Media Room', icon: MediaRoomIcon },
  { id: 'connectivity', label: 'Connectivity', icon: ConnectivityIcon },
  { id: 'property-type', label: 'Property Type', icon: PropertyTypeIcon },
  { id: 'award-feature', label: 'Award/Feature', icon: AwardFeatureIcon },
  {
    id: 'fireplace-heating',
    label: 'Fireplace/Heating',
    icon: FireplaceHeatingIcon,
  },
  { id: 'other', label: 'Other', icon: OtherIcon },
];

/** Look up a feature type by ID. Returns undefined if not found. */
export function getFeatureType(
  typeId: string,
): ListingFeatureItemInfo | undefined {
  return FEATURE_TYPES.find(featureType => featureType.id === typeId);
}

// ─── Sample Titles ────────────────────────────────────────────────────────

/** Predefined sample titles for each feature type. */
export const FEATURE_SAMPLE_TITLES: Record<
  realestatelst.ListingFeatureType,
  string[]
> = {
  'pool-water': [
    'Heated infinity pool with spa',
    'Saltwater pool with waterfall',
    'Indoor lap pool',
    'Resort-style pool & hot tub',
    'Private beach access',
  ],
  'garage-parking': [
    '3-car attached garage',
    'Electric vehicle charging station',
    'Oversized 2-car garage with workshop',
    'Covered carport with storage',
    'Circular driveway with guest parking',
  ],
  'garden-landscape': [
    'Mature landscaping & privacy hedges',
    'Professional garden with irrigation',
    'Rooftop terrace garden',
    'Native drought-resistant landscaping',
    'Fruit orchard with raised beds',
  ],
  security: [
    'Gated entry with security system',
    '24/7 monitored alarm system',
    'Smart lock & video doorbell',
    'Full perimeter security cameras',
    'Safe room with reinforced door',
  ],
  'smart-home': [
    'Smart home automation throughout',
    'Voice-controlled lighting & climate',
    'Integrated smart thermostat',
    'Automated blinds & shades',
    'Whole-home audio system',
  ],
  'floor-plan': [
    'Open-concept floor plan',
    'Split-level design with vaulted ceilings',
    'Single-story living with bonus loft',
    'Dual primary suites',
    'In-law suite with separate entrance',
  ],
  'luxury-premium': [
    'Italian marble countertops',
    'Custom millwork & crown molding',
    'Designer fixtures throughout',
    'Imported hardwood flooring',
    'Floor-to-ceiling windows',
  ],
  'gated-private': [
    'Private gated community',
    'Gated estate with guard house',
    'End-of-cul-de-sac privacy',
    'Walled courtyard entry',
    'Secluded wooded lot',
  ],
  'solar-energy': [
    'Owned solar panel system',
    'Geothermal heating & cooling',
    'Tesla Powerwall battery backup',
    'Energy Star certified home',
    'Net-zero energy ready',
  ],
  entertainment: [
    'Outdoor kitchen with built-in grill',
    'Custom wine cellar',
    'Covered patio with firepit',
    'Built-in outdoor speakers',
    'Game room with wet bar',
  ],
  'kitchen-dining': [
    "Chef's kitchen with island",
    'Sub-Zero & Wolf appliances',
    "Butler's pantry with wine fridge",
    'Breakfast nook with bay window',
    'Double oven & gas cooktop',
  ],
  'fitness-gym': [
    'Private home gym',
    'Indoor basketball/sport court',
    'Yoga studio with mirrors',
    'Sauna & steam room',
    'Outdoor fitness area',
  ],
  'office-tech': [
    'Dedicated home office with built-ins',
    'Wired Ethernet in every room',
    'Soundproof office/studio',
    'Library with floor-to-ceiling shelves',
    'Dual-monitor desk nook',
  ],
  'media-room': [
    'Home theater with surround sound',
    'Dedicated media room with projector',
    'Soundproofed entertainment room',
    'Built-in screen & 4K projector',
    'Stadium seating media lounge',
  ],
  connectivity: [
    'Whole-home Wi-Fi mesh system',
    'Fiber optic internet ready',
    'Pre-wired for smart home devices',
    'Cat6 wiring throughout',
    'Dedicated server/network closet',
  ],
  'property-type': [
    'Single-family detached home',
    'Luxury condominium',
    'Townhouse with private rooftop',
    'Multi-family duplex',
    'Estate on acreage',
  ],
  'award-feature': [
    'LEED certified green building',
    'Award-winning architect design',
    'Historic landmark property',
    'Parade of Homes winner',
    'AIA design award recipient',
  ],
  'fireplace-heating': [
    'Gas fireplace in living room',
    'Wood-burning stone fireplace',
    'Dual-zone radiant floor heating',
    'Outdoor fireplace on patio',
    'Three-sided see-through fireplace',
  ],
  other: [],
};
